var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWoocommerce({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_480_3342",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_480_3342",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAIAAABvFaqvAAAACXBIWXMAAAsTAAALEwEAmpwYAAADi0lEQVQ4jd2U3W9TdRjHn/PW05dz2q5b30bZ6jZWcU2Xlb0QQiCCzgvRMjSKiYKZF+jF4q2amPgH6N2iaKIhKBhIxAQXjEgWrONNttVtsK3Ttd1K166l57Sn7Tk9PS8/Lxa5MoZELoif2+ebz9X3+WIIIXgU4I/E8v8WkVJZvPzBeS5ZsG5zIF1/cCBIQirXZKFuarYYzEZNUQEBhmMPAgghQIAQYtzMgfcOE0PSk1pDc3S6uFQBMNAVXSpWNVWvFASH3znw1v5qrnxvJilxNYmvSWWRMlGAoFasChleKtWksigVxXw8S+w3hI+efaf7uVDs9BROEA1RtjQzgEDIlJ796Mj2oa67F6ZlQXrmw8M7XwjripZf2lDEhsFC7x0bDh4ZIGmisJJT6gpJWenSWrEl4GU9ttxipqXLHRk/PnfmurDBe0JtfLKQnU+/8d27jMcGANsHOy+OnVq9Gj/+6ZuOTjcA+AY61Iaaiq7gWl3NLqwDAOu186vFXcf20azJ5nM0d7gAYPHiTO8rg4zHFv144vsTXwJA93Bv6OV+R6c79s3U2aPjADA4+jRuIEmcIoqrmwBAGilP77Ydw0EAYLx231AHANRLtfCxfXK1/vu3tyiTAQCaOpxN/hak6bNfX+NTRbXeYDw2o9VIUiaDkOYBoDXU7gv7AYBP5D2hNtbbhBBqiIrd3yKsc/cX8k+92rultvuaVVUrxDedATdpNAgZvi5IOG0xlDKcVKrtjIQDz/etXYtfev8cQRHWVnujJufjG5WNkq29uW90aM+JgwAQO3ODSxUomgq+FN799kEAWJqYVSQFx3CikitnY2tb7bhzYTp19Y/NhTQAaLIiFas3P7sCACMnR9v2BlLR5eUf5xcnYgBw6JPXe0b6c3fSc+duMS6WOPTEgUZFNjvM7Xu6MzOJmycnGa81dzcTHOmnzHT8p/nMbLJ2X1CqcvLX+I3PJ61eWznNcX/mNEm9dztxffxnQICTBPbbF5O3v4pa3GzPi+HlS3OVTcHiZLhEIRgJOwOtM6enMByTK3WkI13TadZoYGhd0yvZsiI1MAxjXCyG48HILkzXtKUfZstpTiyLJtZEmWnQdCBwka8iRbM4rXJNSvwSVyXFscPt390lC3X870fRAYGOzC62J9KPPcyw8cnC9Klobm79tfNjpIH8x8xDibZYuTzPOK2tff7/Kvp3Hr9he/xEfwEIyrbrmZjc3wAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWoocommerce);
export default __webpack_public_path__ + "static/media/icon-woocommerce.01ca13defcd352b15b582e9e3e1850e0.svg";
export { ForwardRef as ReactComponent };